<template>
  <div v-if="visibility" class="status-wrapper uk-margin-bottom">
    <div class="status">
      <div v-if="status.price" class="section">
        <div class="section-label">Payment</div>
        <div class="section-bits">
          <div class="bit">
            <div class="bit-value">{{ appointment.payment.amount|price }}</div>
            <div class="bit-label">Amount</div>
          </div>
        </div>
      </div>
      <div v-if="status.emergency" class="section">
        <div class="section-label">Emergency</div>
        <div class="section-bits">
          <div class="bit">
            <div class="bit-value">
              <template v-for="(complaint, index) in appointment.emergency.complaints">
                <span :key="index" class="item">
                  {{ complaints.find(c => c.id === complaint).value }}<span class="separator">,</span>
                </span>
              </template>
            </div>
            <div class="bit-label">Complaint</div>
          </div>
          <div v-if="appointment.emergency.features.length" class="bit">
            <div class="bit-value">
              <template v-for="(feature, index) in appointment.emergency.features">
                <span :key="index" class="item">
                  {{ practiceFeatures.find(f => f.id === feature).value }}<span class="separator">,</span>
                </span>
              </template>
            </div>
            <div class="bit-label">Features</div>
          </div>
        </div>
      </div>
      <div v-if="status.dentist" class="section">
        <div class="section-label">Dentist</div>
        <div class="section-bits">
          <div class="bit">
            <div class="bit-value">{{ practice }}</div>
            <div class="bit-label">Practice</div>
          </div>
          <div class="bit">
            <div class="bit-value">{{ $moment(appointment.dentist.date, 'YYMMDD').format('DD/MM/YYYY') }}</div>
            <div class="bit-label">Date</div>
          </div>
          <div class="bit">
            <div class="bit-value">{{ $helpers.timeBits.find(b => b.id === appointment.dentist.bit).time.short }}</div>
            <div class="bit-label">Time</div>
          </div>
        </div>
      </div>
      <div v-if="status.customer" class="section">
        <div class="section-label">Customer</div>
        <div class="section-bits">
          <div class="bit">
            <div class="bit-value">{{ appointment.customer.name.first }}</div>
            <div class="bit-label">First Name</div>
          </div>
          <div class="bit">
            <div class="bit-value">{{ appointment.customer.name.last }}</div>
            <div class="bit-label">Last Name</div>
          </div>
          <!-- <div class="bit">
            <div class="bit-value">{{ appointment.customer.phone }}</div>
            <div class="bit-label">Phone</div>
          </div>
          <div class="bit">
            <div class="bit-value">{{ appointment.customer.email }}</div>
            <div class="bit-label">Email</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentAppointmentStatus',

  filters: {
    // Format Price
    price: (value) => {
      if (!value) return ''
      const price = value.toString()
      return `£${price.slice(0, price.length - 2)}.${price.slice(price.length - 2, price.length)}`
    }
  },

  props: {
    appointment: {
      type: Object,
      required: true
    },
    visibility: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  computed: {
    status() {
      return {
        emergency: !Object.values(this.appointment.emergency).includes(null),
        dentist: !Object.values(this.appointment.dentist).includes(null),
        customer: !Object.values(this.appointment.customer.name).includes(null),
        price: this.appointment.payment.amount !== null
      }
    },

    complaints() {
      return this.$helpers.complaints
    },

    practiceFeatures() {
      return this.$helpers.practiceFeatures
    },

    practice() {
      const dentist = this.$store.getters['dentists/find'](this.appointment.dentist.id)
      return `${dentist.name} - ${dentist.location.city}`
    }
  }

  // methods: {
  //   changeSection(section) {
  //     this.$bus.$emit('change-section', section)
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.status-wrapper {
  display: flex;
  justify-content: center;

  .status {
    display: inline-flex;
    max-width: 100%;
    margin: 0 auto;
    overflow-x: auto;
    background-color: $colour-light;
    box-shadow: $box-shadow;

    .section {
      &:not(:last-of-type) {
        .section-label {
          border-right: 2px solid $colour-light;
        }

        .section-bits {
          border-right: 2px solid $colour-grey;
        }
      }


      .section-label {
        padding: 6px 16px;
        background-color: $colour-primary;
        color: $colour-light;
        font-weight: 500;
        text-align: center;
      }

      .section-bits {
        display: flex;

        .bit {
          text-align: center;
          white-space: nowrap;

          &:only-child {
            width: 100%;
          }

          &:not(:last-of-type) {
            border-right: 1px solid $colour-grey;
          }

          .bit-label {
            padding: 6px;
            border-top: 1px solid $colour-grey;
            font-size: .7em;
            text-transform: uppercase;
          }

          .bit-value {
            padding: 6px 12px;

            .item:last-of-type .separator {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
